import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full text-center py-4 bg-gray-100 dark:bg-gray-900 text-gray-600 dark:text-gray-400 fixed bottom-0 border-t border-gray-200 dark:border-gray-800">
      &copy; {currentYear}{" "}
      <a
        href="https://ishan.vip"
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 dark:text-blue-400 hover:underline"
      >
        Ishan Jaiswal
      </a>
    </footer>
  );
}

export default Footer;